import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
// @ts-ignore
import createLogger from 'vuex/dist/logger';
import modules from './modules';
import './api';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store: StoreOptions<RootState> = {
    state: {
        version: process.env.VUE_APP_VERSION,
        page_loading: false,
        locale: 'nl_BE',
    },
    modules,
    strict: debug,
    getters: {
        locale(state: RootState): string {
            return state.locale;
        },
        pageLoading(state: RootState): boolean {
            return state.page_loading;
        },
    },
    mutations: {
        PAGE_LOADING(state: RootState) {
            state.page_loading = true;
        },
        PAGE_LOADED(state: RootState) {
            state.page_loading = false;
        },
    },
    actions: {
        startLoadingPage({ commit }: any) {
            commit(`PAGE_LOADING`);
        },
        stopLoadingPage({ commit }: any) {
            commit(`PAGE_LOADED`);
        },
        reset({ commit }: any) {
            const promises: any = [];
            Object.keys(modules).forEach((moduleName: string) => {
                commit(`${moduleName}/RESET`);
                promises.push(Promise.resolve());
            });

            return Promise.all(promises).then(() => Promise.resolve());
        },
    },
    plugins: debug ? [createLogger()] : [],
};

export default new Vuex.Store<RootState>(store);
